import agent from "../api/agent";


export interface ProductImage {
  id: number;
  path: string;
  imagetype: string;
}

export interface Product {
  id: number;
  name: string;
  description: string;
  short_description: string;
  sku: string;
  category_id: number;
  sub_category_id: string;
  packaging_type: string;
  hsn_code: string;
  tax: string;
  quantity: string;
  unit: string;
  weight: number | null;
  daily_capacity: string;
  expiry_in_days: string;
  display_sequence_number: string;
  keywords: string;
  how_it_works: string;
  is_active: boolean;
  product_type: string;
  base_price: string;
  base_offer: string;
  base_offer_type: string;
  base_quantity: string;
  base_unit: string;
  base_mrp: string;
  created_at: string; // ISO date
  updated_at: string; // ISO date
  cess: number;
  shelf_life: string;
  max_quantity_quick: string;
  max_quantity_standard: string;
  base_denomination: string;
  base_denomination_uom: string;
  base_ingredient: string;
  images: ProductImage[];
}


export const getProducts = () => {
  return agent.Product.getAll();
};